"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function filterKey(subject, callbackfn, thisArg) {
    return Object.keys(subject).filter(callbackfn, thisArg);
}
exports.filterKey = filterKey;
//# sourceMappingURL=filterKey.js.map